<template id="dlgThingStatsTmpl" >
  <v-dialog v-model="dlgThingStatsIsOpen" fullscreen hide-overlay transition="dialog-bottom-transition" >
      <v-card>
        <v-toolbar color="primary" dark>
            <v-btn icon dark v-on:click="closeThingStats()"><v-icon>close</v-icon></v-btn>
            <v-toolbar-title v-if="mapDetailObj != null && poiStatsObj != null">
              {{ $t('lbl.thingStats')}}: {{mapDetailObj.map_name}} - {{poiStatsObj.poi_name}}
            </v-toolbar-title>
        </v-toolbar>
        <div v-if="isEmptyObj(poiStatsObj) == false && dlgThingStatsIsOpen == true">

            <v-row no-gutters class="mt-4">
              <v-col cols="12" class="text-left text-md-center">
                <strong>{{ $t('lbl.statsMinute')}}</strong>
              </v-col>
             </v-row>
            <v-row no-gutters v-if="isEmptyObj(chartDataMinute) == false">       
              <v-col cols="12">
                <ct-vuechartjs-line :chart-data="chartDataMinute"></ct-vuechartjs-line>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="isEmptyString(chartMsgMinute) == false">    
              <v-col cols="12">
                {{chartMsgMinute}}
              </v-col>
            </v-row>
           
            <v-row no-gutters class="mt-4"> 
              <v-col cols="12" class="text-left text-md-center">
                <strong>{{ $t('lbl.statsHour')}}</strong>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="isEmptyObj(chartDataHour) == false">    
              <v-col cols="12">
                <ct-vuechartjs-line :chart-data="chartDataHour"></ct-vuechartjs-line>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="isEmptyString(chartMsgHour) == false">    
              <v-col cols="12">
                {{chartMsgHour}}
              </v-col>
            </v-row>

            <v-row no-gutters class="mt-4"> 
              <v-col cols="12" class="text-left text-md-center">
                <strong>{{ $t('lbl.statsDay')}}</strong>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="isEmptyObj(chartDataDay) == false">   
              <v-col cols="12">
                <ct-vuechartjs-line :chart-data="chartDataDay"></ct-vuechartjs-line>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="isEmptyString(chartMsgDay) == false">    
              <v-col cols="12">
                {{chartMsgDay}}
              </v-col>
            </v-row>

            <v-row no-gutters class="mt-4"> 
              <v-col cols="12" class="text-left text-md-center">
                <strong>{{ $t('lbl.statsMonth')}}</strong>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="isEmptyObj(chartDataMonth) == false"> 
              <v-col cols="12">
                <ct-vuechartjs-line :chart-data="chartDataMonth"></ct-vuechartjs-line>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="isEmptyString(chartMsgMonth) == false">    
              <v-col cols="12">
                {{chartMsgMonth}}
              </v-col>
            </v-row>


      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

import ctVuechartjsLine from "@/components/commons/ctVuechartjsLine.vue";

export default {
    i18n,
    data: () => ({
      thingStatsInterval: null,
      dlgThingStatsIsOpen: false,
      input_poi_id: null,
      poiStatsObj: null,
      chartDataMonth: null,
      chartMsgMonth: null,
      chartDataDay: null,
      chartMsgDay: null,
      chartDataHour: null,
      chartMsgHour: null,
      chartDataMinute: null,
      chartMsgMinute: null,
    }),
    props: ['orgid', 'siteid', 'mapDetailObj'],
    components:{
      "ct-vuechartjs-line":ctVuechartjsLine
    },
    methods: {
      openThingStats(poi_id) 
      {
        this.input_poi_id = poi_id;
        this.dlgThingStatsIsOpen = true;
        events.$emit(constants.EVENT_DIALOG_STATS_OPEN);
        
        this.loadPoiStats();
      },
      closeThingStats() 
      {
        this.dlgThingStatsIsOpen = false;
        this.poiDetailObj = null;
        events.$emit(constants.EVENT_DIALOG_STATS_CLOSE);
      },
      loadPoiStats()
      {
        if(this.isEmptyString(this.orgid))  
        {
          this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
        }
        else if(this.isEmptyString(this.siteid))
        {
          this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
        } 
        else if(this.isEmptyObj(this.mapDetailObj) || (!this.isEmptyObj(this.mapDetailObj) && this.isEmptyString(this.mapDetailObj.sitemap_id) ))
        {
          this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
        }
        else if(this.isEmptyString(this.input_poi_id))   
        {
          this.$root.setDialogMsg(i18n.t('err.poiSelectedNotValid'));
        }
        else
        {
          var endpoint2go = constants.ENDPOINT_GATEWAY_POI_STATS;
          endpoint2go += "?org=" + this.orgid;
          endpoint2go += "&site=" + this.siteid;
          endpoint2go += "&map=" + this.mapDetailObj.sitemap_id;
          endpoint2go += "&poi=" +  this.input_poi_id;
          //endpoint2go += "&accessToken=" + this.getUserAccessToken();
          //this.$root.genericGetCallEngine(endpoint2go, this.callbackLoadPoiStats, 'err.loadingPoi');
          //alert(endpoint2go);
          this.globalPageLoading = true;

          //=== RESET
          this.chartDataMonth = null;
          this.chartMsgMonth = null;
          this.chartDataDay = null;
          this.chartMsgDay = null;
          this.chartDataHour = null;
          this.chartMsgHour = null;
          this.chartDataMinute = null;
          this.chartMsgMinute = null;

          this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadPoiStats, 'err.loadingPoi');
        }
      },
      callbackLoadPoiStats(responseData) 
      {
          if(!this.isEmptyObj(responseData))
          {
            this.poiStatsObj = responseData;
            this.generateCharts();
            this.globalPageLoading = false;
          } 
          else 
          {
            this.$root.setDialogMsg(i18n.t('err.loadingPoi'));
          }
      },
      generateCharts()
      {
        //console.log(this.poiStatsObj);
        if(!this.isEmptyObj(this.poiStatsObj.thing_0_stats_month_values))
        {
          this.chartDataMonth = this.generateSingleChart(this.poiStatsObj.thing_0_stats_month_values);
        }
        if(!this.isEmptyString(this.poiStatsObj.thing_0_stats_month_msg))
        {
          this.chartMsgMonth = this.poiStatsObj.thing_0_stats_month_msg;
        }

        if(!this.isEmptyObj(this.poiStatsObj.thing_0_stats_day_values))
        {
          this.chartDataDay = this.generateSingleChart(this.poiStatsObj.thing_0_stats_day_values);
        }
        if(!this.isEmptyString(this.poiStatsObj.thing_0_stats_day_msg))
        {
          this.chartMsgDay = this.poiStatsObj.thing_0_stats_day_msg;
        }

        if(!this.isEmptyObj(this.poiStatsObj.thing_0_stats_hour_values))
        {
          this.chartDataHour = this.generateSingleChart(this.poiStatsObj.thing_0_stats_hour_values);
        }
        if(!this.isEmptyString(this.poiStatsObj.thing_0_stats_hour_msg))
        {
          this.chartMsgHour = this.poiStatsObj.thing_0_stats_hour_msg;
        }

        if(!this.isEmptyObj(this.poiStatsObj.thing_0_stats_minute_values))
        {
          this.chartDataMinute = this.generateSingleChart(this.poiStatsObj.thing_0_stats_minute_values);
        }
        if(!this.isEmptyString(this.poiStatsObj.thing_0_stats_minute_msg))
        {
          this.chartMsgMinute = this.poiStatsObj.thing_0_stats_minute_msg;
        }

      }, 
      generateSingleChart(values) 
      {
        var chartDataObj = null;
        if(!this.isEmptyObj(values))
        {
          var valuesArray = [];
          var labelsArray = [];
          var chartLabel = this.poiStatsObj.thing_0_name;
          for (var i = 0; i < values.length; i++ ) 
          {
            var myValueObj = values[i];
            valuesArray[i] = myValueObj.value;
            labelsArray[i] = myValueObj.timestamp;
            if( i == 0) {
              chartLabel = myValueObj.units;
            }
          }

          chartDataObj = {
            labels: labelsArray,
            datasets: [
              {
                label: chartLabel,
                backgroundColor: "#2A3F54",
                borderColor: "#2A3F54",
                fill: false,
                data: valuesArray
              },
            ]
          };
        } 
        return chartDataObj;
      }
  
    }
};
</script>